import { Response as ClientResponse } from '@finch-api/common/dist/internal/connect/validate';
import { ProviderConfig } from '@finch-api/common/dist/internal/connect/validate';
import styled from 'styled-components';
import InstructionItem from 'components/Instruction/InstructionItem';
import InstructionBox from 'components/Instruction/InstructionBox';
import InstructionItemsBox from 'components/Instruction/InstructionItemsBox';
import COLORS from 'constants/colors';
import { AdvertasingIcon } from 'components/Icons/AdvertasingIcon';
import { AddModeratorIcon } from 'components/Icons/AddModeratorIcon';
import { AccountIcon } from 'components/Icons/AccountIcon';
import { useEffect } from 'react';
import { usePopOutInstructionsLink } from 'store/pop-out-instructions';

interface WelcomeProps {
  client: ClientResponse;
  provider: ProviderConfig;
}

const InstructionText = styled.p`
  color: ${COLORS.FINCH.BLACK};
  font-family: Inter;
  padding: 6px 8px 6px 8px;
  font-size: 14px;
  font-style: Medium;
  font-weight: 600;
  line-height: 150%;
  vertical-align: middle;
`;

const Welcome = ({ provider }: WelcomeProps) => {
  const { setPopOutInstructionsLink } = usePopOutInstructionsLink();

  // Clear popout instructions when welcome page loads
  useEffect(() => {
    setPopOutInstructionsLink(null, null);
  }, [setPopOutInstructionsLink]);

  return (
    <InstructionBox>
      <InstructionText>
        This process will be completed in three parts:
      </InstructionText>
      <InstructionItemsBox>
        <InstructionItem
          icon={<AdvertasingIcon />}
          badgeColor={COLORS.GRAY.GRAY_600}
        >
          Retrieve your Web Service URL and Company Short Name
        </InstructionItem>
        <InstructionItem
          icon={<AddModeratorIcon />}
          badgeColor={COLORS.GRAY.GRAY_600}
        >
          Create a Service Profile for Finch and assign it the necessary
          permissions
        </InstructionItem>
        <InstructionItem
          icon={<AccountIcon />}
          badgeColor={COLORS.GRAY.GRAY_600}
        >
          Create a Service Account
        </InstructionItem>
      </InstructionItemsBox>
      <InstructionText style={{ fontWeight: 400 }}>
        These details are stored in different areas of {provider.displayName}.
        Finch will collect them across three screens to make setup easier.
      </InstructionText>
    </InstructionBox>
  );
};

export default Welcome;
